/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['rest/reverseGeocode', 'model/reverseGeocode/reverseGeocode', '../chain', '../validators', '../converters',
    '../utils', 'model/reverseGeocode/batchReverseGeocode'], function(reverseGeocode, model, chain, validators,
    converters, utils, batchModel) {
    'use strict';

    var TYPES = {
            reverseGeocode: 'reverseGeocode',
            crossStreetLookup: 'reverseGeocode/crossStreet'
        }, fields = {
            key: {
                validator: validators.string
            },
            position: {
                converter: converters.point,
                validator: validators.point,
                required: true
            },
            spatialKeys: {
                validator: validators.bool
            },
            heading: {
                validator: validators.number
            },
            radius: {validator: validators.naturalInteger},
            protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')}
        };

    function ReverseGeocodeBase(options) {
        this.options = options;
        this.defaultFields = utils.clone(fields);
        this.fields = {};
    }

    ReverseGeocodeBase.prototype.TYPE = TYPES;
    ReverseGeocodeBase.prototype.construct = function() {
        var mergedFields = utils.addFields.call(this, this.fields);
        var batchFields = {
            batchItems: {
                validator: validators.arrayOf(mergedFields),
                converter: converters.arrayOf(mergedFields)
            },
            type: {
                validator: validators.string
            }
        };

        if (Array.isArray(this.options)) {
            return chain.call(this, batchFields, this.handleBatchChain, {
                batchItems: this.options,
                type: this.fields.type.defaultValue
            });
        } else {
            return chain.call(this, mergedFields, this.handleChain, this.options);
        }
    };

    ReverseGeocodeBase.prototype.handleBatchChain = function(data, callback) {
        reverseGeocode.batch(data, function(response) {
            callback.call(this, batchModel(response));
        });
    };

    ReverseGeocodeBase.prototype.handleChain = function(data, callback) {
        reverseGeocode.reverseGeocode(data, function(response) {
            callback.call(this, model(response)[0]);
        });
    };

    function reverseGeocodeConstructor(options) {
        return (new ReverseGeocodeBase(options)).construct();
    }

    reverseGeocodeConstructor.prototype.constructor = ReverseGeocodeBase;

    return reverseGeocodeConstructor;
});



// WEBPACK FOOTER //
// ./services/reverseGeocode/reverseGeocodeBase.js